@if (!isHidden) { @if (showLabel) {
<!-- Bottom-nav variant: stacked icon + caption filling the nav cell. Can't use
     mat-icon-button here, it forces a fixed circular box. -->
<button
  type="button"
  class="chat-button chat-button--with-label"
  [ngClass]="{ 'chat-button--active': isActive }"
  (click)="onClick()"
  [attr.aria-label]="'CHAT.TITLE' | translate"
>
  <span class="chat-button__icon-wrapper">
    <fa-icon [icon]="['fass', 'comments']" class="chat-button__icon"></fa-icon>
    @if (unreadCount > 0) {
    <span
      class="chat-button__badge chat-button__badge--floating"
      [attr.aria-hidden]="true"
      >{{ badgeLabel }}</span
    >
    }
  </span>

  <span class="chat-button__label">{{ 'CHAT.TITLE' | translate }}</span>
</button>
} @else {
<!-- Header variant: same element, directives and classes as the notification
     bell so both header icons share Material's hover/ripple and badge. -->
<button
  mat-icon-button
  type="button"
  class="chat-button__button btn btn--sm btn--icon btn--no-bg"
  (click)="onClick()"
  [attr.aria-label]="'CHAT.TITLE' | translate"
>
  <fa-icon [icon]="['fass', 'comments']" class="chat-button__icon"></fa-icon>
  @if (unreadCount > 0) {
  <span class="chat-button__badge" [attr.aria-hidden]="true">{{
    badgeLabel
  }}</span>
  }
</button>
} }
